import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M17.19.22a.75.75 0 0 1 0 1.06L1.28 17.19a.75.75 0 0 1-1.06-1.06L16.13.22a.75.75 0 0 1 1.06 0Z",
		fill: "#262626",
		fillRule: "evenodd",
		clipRule: "evenodd"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20d%3D%22M17.19.22a.75.75%200%200%201%200%201.06L1.28%2017.19a.75.75%200%200%201-1.06-1.06L16.13.22a.75.75%200%200%201%201.06%200Z%22%20fill%3D%22%23262626%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
